document.addEventListener("DOMContentLoaded", function () {
    const dropdown = document.querySelector(".categories-dropdown");
    const toggleButton = dropdown.querySelector(".dropdown-toggle");
    const menu = dropdown.querySelector(".dropdown-menu");

    toggleButton.addEventListener("click", function (e) {
        e.preventDefault(); // Mencegah default klik tombol
        const isVisible = menu.style.display === "block";
        menu.style.display = isVisible ? "none" : "block"; // Toggle tampil/tutup
    });

    // Tutup dropdown jika klik di luar
    document.addEventListener("click", function (e) {
        if (!dropdown.contains(e.target)) {
            menu.style.display = "none";
        }
    });
});
